export default "__VITE_ASSET__j7vY6COJ__"